import { createSlice } from '@reduxjs/toolkit';
import { fetchAuthToken } from '../../api/tokens';

interface IUserState {
  id: string;
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  avatar: null | string;
  autoGenerated: boolean;
  autoLogin: boolean;
  isLoaded: boolean;
}

const initialState = {
  id: '',
  email: '',
  name: '',
  firstName: '',
  lastName: '',
  avatar: null,
  autoGenerated: false,
  autoLogin: false,
  isLoaded: !fetchAuthToken(),
} as IUserState;

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser: (state: IUserState, action) => ({
      ...state,
      ...action.payload,
      isLoaded: true,
    }),
    resetUser: () => ({
      ...initialState,
      isLoaded: true,
    }),
  },
});

export const { updateUser, resetUser } = userSlice.actions;

export default userSlice.reducer;
